import { useState } from "react";
import { FaChartLine, FaCogs, FaSave } from "react-icons/fa";
import LiquidationResults from "components/BacktestResults/LiquidationResults";
import TP_SLResults from "components/BacktestResults/TP_SLResults";
import { IoClose } from "react-icons/io5";
import { useCooldownAction } from "hooks/useCooldownAction";
import apiUtils from "utils/apiutils";
import { toast } from "sonner";

const BacktestResults = ({ results, setActiveTab, resultwithid }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [backtestName, setBacktestName] = useState("");
  const runWithCooldown = useCooldownAction();
  
  const handleSubmit = async () => {
    if (!backtestName.trim()) {
      toast.error("Please enter a backtest name.");
      return;
    }

    await runWithCooldown(async () => {
      try {
        const payload = {
          ...results.data,
          Backtest_Name: backtestName,
        };

        const response = await apiUtils.post('/user_backtesting/save_backtest_data', payload, { showToast: false });

        if (response) {
          toast.success("Backtest saved successfully!");
          setIsModalOpen(false);
          setActiveTab('saved')
          setBacktestName("");
        }
      } catch (err) {
        console.error("Error saving backtest:", err);
      } finally {
        setIsModalOpen(false);
      }
    })
  };

  if (!results) return null;
  if (!results.strategy_type) {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh] bg-card rounded-2xl text-center p-8 shadow-md">
        <FaCogs className="text-primary text-6xl mb-4 animate-spin-slow" />
        <h2 className="text-2xl font-bold text-white mb-2">
          Configure Your Backtest
        </h2>
        <p className="text-gray-400 mb-6 max-w-md">
          It looks like you haven’t configured a strategy yet. Set up your
          backtest parameters and run it to view detailed results.
        </p>

        <button
          onClick={() => setActiveTab("configure")}
          className="flex items-center gap-2 bg-primary hover:bg-primary/90 text-secondary font-semibold px-5 py-2.5 rounded-xl transition-all duration-200"
        >
          <FaChartLine />
          Go to Configuration
        </button>
      </div>
    );
  }

  // Choose component dynamically
  const renderStrategyComponent = () => {
    switch (results.strategy_type) {
      case "TP_SL":
        return <TP_SLResults results={results.data} />;
      case "Liquidation":
        return <LiquidationResults results={results.data} />;
      default:
        return (
          <div className="text-gray-400 flex justify-center p-6">
            No results available.
          </div>
        );
    }
  };


  const title =
    results.strategy_type === "TP_SL"
      ? "TP SL Backtest Summary"
      : results.strategy_type === "Liquidation"
        ? "Liquidation Backtest Summary"
        : " ";

  return (
    <div className="p-6 bg-secondary rounded-2xl shadow-md">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-6 gap-4">
        <h2 className="text-xl font-bold text-white flex items-center gap-3">
          <FaChartLine className="text-primary text-2xl" />
          {title}
        </h2>
        {/* resultwithid */}
        {/* {resultwithid && <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-secondary px-4 py-2 rounded-xl font-semibold transition-all duration-200"
        >
          <FaSave className="text-lg" />
          Save Backtest
        </button>} */}

      </div>

      {/* Strategy-specific Results */}
      <div>{renderStrategyComponent()}</div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
          <div className="bg-gray-800 text-white rounded-2xl shadow-lg w-11/12 sm:w-[400px] p-6 relative">
            {/* Close Button */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-white"
            >
              <IoClose size={22} />
            </button>

            {/* Modal Title */}
            <h3 className="text-xl font-semibold mb-4 text-center">
              Save Backtest
            </h3>

            {/* Input */}
            <div className="mb-5">
              <label className="block text-sm text-gray-300 mb-2">
                Backtest Name
              </label>
              <input
                type="text"
                value={backtestName}
                onChange={(e) => setBacktestName(e.target.value)}
                placeholder="Enter backtest name"
                className="w-full px-3 py-2 rounded-lg bg-gray-700 border border-gray-600 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Submit */}
            <button
              onClick={handleSubmit}
              className="w-full bg-primary text-secondary py-2 rounded-xl font-semibold transition-all"
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BacktestResults;
